export const handleErrorMessage = (response: Record<string, unknown>) => {
  if (
    'detail' in response &&
    typeof response.detail === 'string' &&
    'success' in response &&
    response.success === false
  ) {
    return response.detail;
  }
  if ('non_field_errors' in response && Array.isArray(response.non_field_errors)) {
    return response.non_field_errors.at(0);
  }
  return null;
};
